var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Watch } from "vue-property-decorator";
import ActivityOverlay from "@shared/components/ActivityOverlay.vue";
import BaseModal from "@shared/components/BaseModal.vue";
import LoggerService from "@shared/services/logger.service";
import ToasterService from "@shared/services/toaster.service";
import { PhotoUploaderService } from "@shared/services/photo-uploader.service";
var EditPhotoModal = /** @class */ (function (_super) {
    __extends(EditPhotoModal, _super);
    function EditPhotoModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logger = new LoggerService();
        _this.toasterService = new ToasterService();
        _this.photoUploaderService = new PhotoUploaderService();
        _this.apiRequest = null;
        _this.activityOverlayTitle = "Uploading...";
        _this.imageSource = "";
        _this.originalFileName = "";
        _this.croppedImageData = "";
        return _this;
    }
    EditPhotoModal.prototype.onShowChanged = function (val, oldVal) {
        if (val == null) {
            return;
        }
        if (val) {
            this.imageSource = "";
        }
    };
    EditPhotoModal.prototype.setImage = function (e) {
        var _this = this;
        var input = e.target;
        if (input == null || input.files == null || input.files.length === 0) {
            return;
        }
        var file = input.files[0];
        if (!file.type.includes("image/")) {
            this.toasterService.showErrorMessage("Please select an image file");
            return;
        }
        if (typeof FileReader !== "function") {
            this.toasterService.showErrorMessage("Sorry, FileReader API not supported. Please contact support.");
        }
        var reader = new FileReader();
        reader.onloadend = function (loadEvent) {
            if (loadEvent == null || loadEvent.target == null) {
                return;
            }
            _this.imageSource = loadEvent.target.result;
            _this.$refs.cropper.replace(_this.imageSource);
        };
        this.originalFileName = file.name;
        reader.readAsDataURL(file);
    };
    EditPhotoModal.prototype.upload = function () {
        var _this = this;
        if (!this.imageSource) {
            return;
        }
        this.croppedImageData = this.$refs.cropper.getCroppedCanvas({
            maxHeight: 800,
            maxWidth: 800,
            minHeight: 200,
            minWidth: 200,
            imageSmoothingQuality: "high"
        }).toDataURL();
        var blob = this.base64ToArrayBuffer(this.croppedImageData);
        this.activityOverlayTitle = "Uploading...";
        this.apiRequest = this.photoUploaderService.uploadPhoto(this.photoType, blob, this.originalFileName)
            .then(function (s) {
            _this.$emit("uploadDone", _this.croppedImageData);
        });
    };
    EditPhotoModal.prototype.deletePhoto = function () {
        var self = this;
        this.toasterService.showConfirmDangerPopup("Are you sure you want to clear existing photo?", function () {
            self.activityOverlayTitle = "Removing...";
            self.apiRequest = self.photoUploaderService.deletePhoto(self.photoType)
                .then(function (s) {
                self.$emit("uploadDone", "");
            });
        });
    };
    EditPhotoModal.prototype.base64ToArrayBuffer = function (base64) {
        base64 = base64.replace(/^data:([^;]+);base64,/gmi, "");
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        this.logger.debug("converting base64 image (size: " + len + ")");
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return new Blob([buffer]);
    };
    __decorate([
        Prop()
    ], EditPhotoModal.prototype, "photoType", void 0);
    __decorate([
        Watch("show")
    ], EditPhotoModal.prototype, "onShowChanged", null);
    EditPhotoModal = __decorate([
        Component({
            components: {
                ActivityOverlay: ActivityOverlay
            }
        })
    ], EditPhotoModal);
    return EditPhotoModal;
}(BaseModal));
export default EditPhotoModal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/shared/components/EditPhotoModal.vue
// module id = 81
// module chunks = 3 4